/* ===================================================================
   RIVERTY PAYMENT LINE - new PagePilot templates
   -------------------------------------------------------------------
   New templates show a lightning (zap) icon + "Sicher bezahlen mit
   Kreditkarte oder PayPal" (English: "Pay securely with credit card or
   PayPal"). Old templates show the Riverty logo + "Zahlen Sie spaeter
   oder in 3 Teilen mit Riverty". Rewrite the text (German or English,
   whichever the page is in) and swap the icon for the same riverty.png
   at 14px high. Added 2026-10-16.
   =================================================================== */
(function () {
  var LOGO = 'https://cdn.shopify.com/s/files/1/0601/8587/0473/files/riverty.png?v=1774172153';
  var DE = 'Zahlen Sie später oder in 3 Teilen mit <b>Riverty</b>';
  var EN = 'Pay later or in 3 installments with <b>Riverty</b>';
  var MATCH = /(Kreditkarte oder|credit card or)\s*PayPal/i;

  var css = document.createElement('style');
  css.textContent =
    'html body .zn-riverty-wrap{width:auto!important;height:auto!important;min-width:0!important;background:transparent!important;border-radius:0!important}' +
    'html body .zn-riverty-logo{display:block!important;height:14px!important;width:auto!important;max-width:none!important;object-fit:contain;margin:0!important}';
  (document.head || document.documentElement).appendChild(css);

  function swap() {
    var icons = document.querySelectorAll('svg[data-lucide="zap"], svg.lucide-zap, i[data-lucide="zap"]');
    for (var i = 0; i < icons.length; i++) {
      var icon = icons[i], wrap = icon.parentElement, row = wrap && wrap.parentElement;
      if (!row || !MATCH.test(row.textContent || '')) continue;
      var texts = row.querySelectorAll('div');
      for (var j = 0; j < texts.length; j++) {
        var t = texts[j];
        if (t.children.length <= 1 && MATCH.test(t.textContent || '')) {
          t.innerHTML = /Kreditkarte/i.test(t.textContent) ? DE : EN;
        }
      }
      var img = document.createElement('img');
      img.src = LOGO; img.alt = 'Riverty'; img.width = 23; img.height = 14;
      img.className = 'zn-riverty-logo';
      wrap.classList.add('zn-riverty-wrap');
      wrap.replaceChild(img, icon);
    }
  }
  swap();
  document.addEventListener('DOMContentLoaded', swap);
  window.addEventListener('load', swap);
  var runs = 0, timer = setInterval(function () { swap(); if (++runs >= 20) clearInterval(timer); }, 500);
})();

/* ===================================================================
   "ACHTUNG!" DATE BOX - old template block on every product page
   -------------------------------------------------------------------
   Old PagePilot templates have a custom_liquid section right above the
   Trustpilot reviews:
     Achtung! Bestellen Sie bis einschliesslich <Wochentag, TT.MM.JJJJ>,
     um von der Rabattaktion zu profitieren.
   (grey #f2f2f2 box, today's date filled in by an inline script).
   New PagePilot templates do not have it. This injects the same markup
   directly above the Trustpilot block (#tp-global-reviews, or the
   section holding a template's own .TP-heading) on every product page
   that lacks #dynamic-discount-message. Added 2026-10-16.
   =================================================================== */
(function () {
  var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
  var isProduct = (meta && meta.page && meta.page.pageType === 'product') || /\/products\//.test(location.pathname);
  if (!isProduct) return;

  var TAGE = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

  function today() {
    var d = new Date();
    var tag = String(d.getDate()).padStart(2, '0');
    var monat = String(d.getMonth() + 1).padStart(2, '0');
    return TAGE[d.getDay()] + ', ' + tag + '.' + monat + '.' + d.getFullYear();
  }

  function anchor() {
    var g = document.getElementById('tp-global-reviews');
    if (g && g.parentNode && !g.hidden) return g;
    var h = document.querySelector('.TP-heading');
    if (!h) return null;
    return h.closest('.shopify-section') || h.closest('.pagepilot-section');
  }

  function inject() {
    if (document.getElementById('dynamic-discount-message')) return true;
    var a = anchor();
    if (!a || !a.parentNode) return false;
    var wrap = document.createElement('div');
    wrap.className = 'pagepilot-section pagepilot-custom-liquid zn-achtung-auto';
    wrap.innerHTML =
      '<div class="pagepilot-wrapper">' +
        '<div id="dynamic-discount-message" style="text-align: center; font-size: 16px; padding: 15px; background-color: #f2f2f2; border-radius: 0px;">' +
          '<span style="font-size: large;"><b>Achtung!</b></span> Bestellen Sie bis einschließlich ' +
          '<span id="today-date" style="color: #C5B79A; font-weight: bold;">' + today() + '</span>' +
          ', um von der Rabattaktion zu profitieren.' +
        '</div>' +
      '</div>';
    a.parentNode.insertBefore(wrap, a);
    return true;
  }

  // The Trustpilot block decides late whether it stays (it removes itself when a
  // template has its own copy), so retry for ~10s until an anchor is settled.
  var runs = 0;
  function tick() { if (inject() || ++runs >= 20) clearInterval(timer); }
  var timer = setInterval(tick, 500);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick); else tick();
})();

/* ===================================================================
   DESKTOP GALLERY ARROWS - old PagePilot templates
   -------------------------------------------------------------------
   Old PagePilot pages show a big image + thumbnail grid on desktop
   (#pp-main-product-image, .pp-thumbnail with onclick ppSetCurrentImage).
   The theme's arrow script only runs on phones (<=768px), so desktop
   had no way to step through the photos except clicking thumbnails.
   This adds a left/right arrow on the big image that clicks the
   previous/next thumbnail (wrapping around), so the thumbnail border
   and any other thumbnail behaviour stay in sync. The current photo is
   read from the big image's src each time, so variant changes that
   swap the image are respected. Added 2026-10-02.
   =================================================================== */
(function () {
  function path(u) {
    return String(u || '').split('?')[0].replace(/^https?:/, '').replace(/^\/\/[^/]+/, '');
  }

  function init() {
    var main = document.getElementById('pp-main-product-image');
    if (!main || main.getAttribute('data-zn-arrows')) return;
    var wrap = main.parentElement;
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('#pp-image-scroll-container .pp-thumbnail'));
    if (!wrap || thumbs.length < 2) return;
    main.setAttribute('data-zn-arrows', '1');

    if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';

    function current() {
      var m = path(main.src);
      for (var i = 0; i < thumbs.length; i++) {
        var img = thumbs[i].querySelector('img');
        if (img && path(img.src) === m) return i;
      }
      return 0;
    }

    function go(step) {
      var n = thumbs.length;
      thumbs[(current() + step + n) % n].click();
    }

    [['left', -1, '‹', 'Vorheriges Bild'], ['right', 1, '›', 'Nächstes Bild']].forEach(function (a) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'zn-pp-desk-arrow zn-pp-desk-arrow-' + a[0];
      b.setAttribute('aria-label', a[3]);
      b.innerHTML = a[2];
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(a[1]); });
      wrap.appendChild(b);
    });
  }

  var css = document.createElement('style');
  css.textContent =
    '.zn-pp-desk-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:10;width:40px;height:40px;' +
    'background:#f5f5f5;border:0;border-radius:8px;display:flex;align-items:center;justify-content:center;' +
    'font-size:26px;line-height:1;color:#333;box-shadow:0 1px 4px rgba(0,0,0,.15);cursor:pointer;user-select:none;' +
    'padding:0 0 3px;transition:background .2s ease}' +
    '.zn-pp-desk-arrow:hover{background:#eaeaea}' +
    '.zn-pp-desk-arrow-left{left:10px}.zn-pp-desk-arrow-right{right:10px}' +
    '@media (max-width:768px){.zn-pp-desk-arrow{display:none!important}}';
  (document.head || document.documentElement).appendChild(css);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', init);
})();

/* ===================================================================
   STOCK ALERT - old template line on every product page
   -------------------------------------------------------------------
   Old PagePilot templates hand-code this block above the bundle picker:
     [red pulse GIF] Nur noch 3 auf Lager
   New PagePilot templates do not, so it is injected here for every
   product page that lacks it - current and future templates alike, no
   template edit needed. Anchor (the line goes directly above it):
     new template: the .shopify-block holding .buy-buttons-block
     old template: the ProductInfo section child holding the cart form
   Pages that already hand-code .stock-alert-container are left alone.
   custom.css hides PagePilot's own dashed alarm-clock stock box.
   Re-applied for ~10s because app scripts re-render parts of the page.
   First in the file for the same reason as the gallery block below.
   =================================================================== */
(function () {
  var GIF = 'https://cdn.shopify.com/s/files/1/0767/6339/8478/files/ezgif.com-resize.gif?v=1698232056';
  var COUNT = 3;

  function anchor() {
    var bb = document.querySelector('.buy-buttons-block');
    var block = bb && bb.closest('.shopify-block');
    if (block && block.parentNode) return block;
    var info = document.querySelector('section[id^="ProductInfo-"]');
    if (!info) return null;
    for (var i = 0; i < info.children.length; i++) {
      if (info.children[i].querySelector('form[action*="/cart/add"]')) return info.children[i];
    }
    return null;
  }

  function build() {
    var box = document.createElement('div');
    box.className = 'stock-alert-container zn-stock-auto';
    box.innerHTML =
      '<div class="stock-alert-item">' +
        '<img src="' + GIF + '" width="20" height="20" alt="">' +
        '<div class="text-block-stock">Nur noch <span class="stock-count">' + COUNT + '</span> auf Lager</div>' +
      '</div>';
    return box;
  }

  function inject() {
    if (document.querySelector('.stock-alert-container')) return;
    var a = anchor();
    if (a) a.parentNode.insertBefore(build(), a);
  }

  var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
  var isProduct = (meta && meta.page && meta.page.pageType === 'product') || /\/products\//.test(location.pathname);
  if (!isProduct) return;

  inject();
  document.addEventListener('DOMContentLoaded', inject);
  window.addEventListener('load', inject);
  var runs = 0, timer = setInterval(function () { inject(); if (++runs >= 20) clearInterval(timer); }, 500);
})();

/* ===================================================================
   PAGEPILOT 2.0 GALLERY - VARIANT IMAGE SWAP
   -------------------------------------------------------------------
   The UNIFIED PRODUCT IMAGE MANAGER in layout/theme.liquid swaps the
   gallery photo when a Wizio bundle dropdown changes. Its ppSetImage()
   only knows the OLD PagePilot gallery:

       #pp-image-scroll-container      (by id)
       img.pp-object-contain / cover

   Pages rebuilt on the new PagePilot template (product.pagepilot.<uuid>)
   render a Swiper instead:

       <pagepilot-product-gallery>
         .pp-product-gallery-main  ->  .swiper-slide[data-media-id]
         img.pp-product-gallery-carousel-image

   None of the old selectors match there, so ppGetMainImg() returns null
   and the swap is a SILENT no-op - the reported "image does not change"
   bug. This adds the missing branch for the new gallery and leaves every
   other page untouched:

     - old PagePilot pages render the theme Flickity slideshow, handled
       by the existing hasFlickity() branch
     - this block exits immediately when no Swiper gallery is present

   Lives here rather than in theme.liquid so the 46KB layout file does
   not have to be rewritten. custom.js is loaded on every page via
   <script src="{{ 'custom.js' | asset_url }}" defer>.

   NOTE: this block is FIRST on purpose. The date code below ends with
   document.getElementById("date_clas").innerHTML = ..., which throws on
   every page that has no #date_clas element (product pages included),
   so anything appended after it would never run.
   =================================================================== */
(function () {
  var READY_DELAY = 1500; // mirrors wizioInitDone in theme.liquid
  var ready = false;
  var variantsById = null;

  function mainSwiper() {
    var main = document.querySelector('.pp-product-gallery-main');
    var swiper = main && main.swiper;
    return (swiper && swiper.slides && swiper.slides.length) ? swiper : null;
  }

  // window.KlarnaThemeGlobals.productVariants is set in theme.liquid from
  // {{ product.variants | json }}, so each variant carries featured_media.id
  // and it matches the slide data-media-id exactly. No fetch needed.
  function variantMap() {
    if (variantsById) return variantsById;
    var list = window.KlarnaThemeGlobals && window.KlarnaThemeGlobals.productVariants;
    if (!list || !list.length) return null;
    variantsById = {};
    for (var i = 0; i < list.length; i++) variantsById[String(list[i].id)] = list[i];
    return variantsById;
  }

  // The gallery lazy-loads: hand the slide its real srcset before we show it,
  // otherwise the customer sees an empty frame for a moment.
  function eagerLoad(slide) {
    var imgs = slide.querySelectorAll('img[data-srcset]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var sizes = img.getAttribute('data-sizes');
      if (sizes) img.sizes = sizes;
      img.srcset = img.getAttribute('data-srcset');
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-sizes');
    }
  }

  function goToMedia(mediaId) {
    var swiper = mainSwiper();
    if (!swiper || !mediaId) return false;

    var slides = Array.prototype.slice.call(swiper.slides);
    var target = null;
    for (var i = 0; i < slides.length; i++) {
      if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) {
        target = slides[i];
        break;
      }
    }
    if (!target) return false;

    eagerLoad(target);

    // Index by CURRENT dom order. The gallery runs loop:true and Swiper
    // reorders its slides as the carousel wraps, so a stored position would
    // point at the wrong photo later. Also use slideTo, not slideToLoop -
    // slideToLoop defers through requestAnimationFrame.
    var index = slides.indexOf(target);
    if (index < 0) return false;

    swiper.slideTo(index, 300);
    return true;
  }

  // Same row resolution as findPickerForSelect() in theme.liquid: scope to the
  // active bundle tier and match by row index, so rows 2 and 3 of a "buy 2/3"
  // bundle resolve to their own variant instead of the first row.
  function pickerFor(select) {
    var tier = document.querySelector('.bdl-quantity-item.active') || document;
    var optClass = select.classList.contains('bdl-quantity-options-0')
      ? '.bdl-quantity-options-0'
      : '.bdl-quantity-options-1';
    var rows = Array.prototype.slice.call(tier.querySelectorAll(optClass));
    var rowIndex = rows.indexOf(select);
    if (rowIndex < 0) rowIndex = 0;
    var pickers = Array.prototype.slice.call(tier.querySelectorAll('.bdl-quantity-variants-picker'));
    return pickers[rowIndex] || pickers[0] || document.querySelector('.bdl-quantity-variants-picker');
  }

  function onChange(event) {
    var target = event.target;
    if (!target || !target.classList) return;
    if (!target.classList.contains('bdl-quantity-options-0') &&
        !target.classList.contains('bdl-quantity-options-1')) return;
    if (!ready) return;
    if (!mainSwiper()) return; // old gallery or no PagePilot gallery: leave it alone

    // Wizio rewrites its hidden variant picker after the change event, so read
    // it on the next tick - same 50ms the existing theme script uses.
    setTimeout(function () {
      var map = variantMap();
      var picker = pickerFor(target);
      if (!map || !picker || !picker.value) return;
      var variant = map[String(picker.value)];
      if (!variant || !variant.featured_media) return;
      goToMedia(variant.featured_media.id);
    }, 50);
  }

  function arm() {
    setTimeout(function () { ready = true; }, READY_DELAY);
  }

  function init() {
    document.addEventListener('change', onChange);

    if (document.querySelector('.bdl-quantity-generate')) {
      arm();
      return;
    }
    // The bundle widget renders async; wait for it, then arm.
    var observer = new MutationObserver(function () {
      if (document.querySelector('.bdl-quantity-generate')) {
        observer.disconnect();
        arm();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); arm(); }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

var today=new Date,n=today.getDay(),dd=String(today.getDate()).padStart(2,"0"),mm=String(today.getMonth()+1).padStart(2,"0"),yyyy=today.getFullYear(),month="",current_day="";n==1?current_day="Montag":n==2?current_day="Dienstag":n==3?current_day="Mittwoch":n==4?current_day="Donnerstag":n==5?current_day="Freitag":n==6?current_day="Samstag":n==7&&(current_day="Sonntag"),mm==1?month="Januar":mm==2?month="Februar":mm==3?month="M\xE4rz":mm==4?month="April":mm==5?month="Mai":mm==6?month="Juni":mm==7?month="Juli":mm==8?month="August":mm==9?month="September":mm==10?month="Oktober":mm==11?month="November":mm==12&&(month="Dezember"),document.getElementById("date_clas").innerHTML=current_day+", "+dd+". "+month;
//# sourceMappingURL=/s/files/1/0583/6478/8885/t/12/assets/custom.js.map?v=1662149651
